import Helper from './Helper';

class ColumnChart {
  constructor(chartMaxHeight, padding = 10) {
    const wrapperSelector = '.ns-chart-boxes';
    const blueSelector = '.ns-box--blue';
    const graySelector = '.ns-box--gray';
    const boxSelector = '.ns-chart-box__box';
    const valSelector = '.ns-chart-box__val';
    const wrapper = [...document.querySelectorAll(wrapperSelector)];
    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    wrapper.forEach(wrap => {
      const gray = wrap.querySelector(graySelector);
      const blue = wrap.querySelector(blueSelector);
      const grayTxt = gray.querySelector(valSelector).innerText.replace(",", ".").replace("%", "");
      const blueTxt = blue.querySelector(valSelector).innerText.replace(",", ".").replace("%", "");
      const numGray = parseFloat(grayTxt);
      const numBlue = parseFloat(blueTxt);
      const boxGray = gray.querySelector(boxSelector);
      const boxBlue = blue.querySelector(boxSelector);

      const bothNegative = (numGray < 0 && numBlue < 0);
      const hasNegative = (numGray < 0 || numBlue < 0);
      const total = (numGray < 0 ? numGray * -1 : numGray) + (numBlue < 0 ? numBlue * -1 : numBlue);

      const line = document.createElement('div');
      line.classList.add('ns-chart-boxes__zero');
      wrap.appendChild(line);

      if (bothNegative) {
        // Beide Negativ
        line.style.top = '0px';

        if (numBlue > numGray) {
          boxGray.style.height = chartMaxHeight + px;
          boxBlue.style.height = (numBlue / numGray * chartMaxHeight) + 'px';
          boxGray.style.marginBottom = padding + 'px';
          boxBlue.style.marginBottom = chartMaxHeight - (numBlue / numGray * chartMaxHeight) +padding+ 'px';
        } else {
          boxGray.style.height = (numGray / numBlue * chartMaxHeight) + 'px';
          boxBlue.style.height = chartMaxHeight + 'px';
          boxBlue.style.marginBottom = padding + 'px';
          boxGray.style.marginBottom = chartMaxHeight - (numGray / numBlue * chartMaxHeight) +padding+ 'px';
        }

      } else if (hasNegative) {
        const negativeNum = numGray < numBlue ? numGray : numBlue;
        const positiveNum = numBlue < numGray ? numGray : numBlue;
        const negativeElement = numGray < numBlue ? boxGray : boxBlue;
        const positiveElement = numBlue < numGray ? boxGray : boxBlue;

        line.style.top = (chartMaxHeight / total * positiveNum) + padding + 'px';

        negativeElement.style.height = (chartMaxHeight * (negativeNum * -1) / total) + 'px';
        positiveElement.style.height = (chartMaxHeight * (positiveNum / total)) + 'px';

        positiveElement.style.marginBottom = chartMaxHeight - (chartMaxHeight * (positiveNum / total)) + 'px';

        // Eines Negativ
      } else {
        // Beide Positiv
        line.style.top = chartMaxHeight + padding + 'px';

        if (numBlue < numGray) {
          boxGray.style.height = chartMaxHeight+'px';
          boxBlue.style.height = (numBlue / numGray * chartMaxHeight) + 'px';
        } else {
          boxGray.style.height = (numGray / numBlue * chartMaxHeight) + 'px';
          boxBlue.style.height = chartMaxHeight + 'px';
        }
      }

      wrap.classList.add("null");

      if (Helper.isInViewport(wrap)) {
        console.log(wrap);
        wrap.classList.remove("null");
        wrap.classList.add("draw");
      }

    });
    if(!isFirefox){
      window.addEventListener('scroll', function (event) {
        // Check if the media query is true
  
        wrapper.forEach(element => {
          if (Helper.isInViewport(element)) {
            element.classList.remove("null");
            element.classList.add("draw");
          }
        });
  
      }, false);
    } else{
      wrapper.forEach(element => {
          element.classList.remove("null");
          element.classList.add("draw");
      });

    }

  }
}

export default ColumnChart;
